// extracted by mini-css-extract-plugin
module.exports = {"container":"customCardMarker_container__9Ez0C","cornerQuantity":"customCardMarker_cornerQuantity__EbjsH"};